import { getCookie, setCookie } from 'cookies-next';
import { useRouter } from 'next/router';
import { i18n } from 'next-i18next';
import { useCallback, useEffect, useMemo, useState } from 'react';

const useLocale = () => {
  const { replace, asPath, pathname, query, locale: routeLocale } = useRouter();
  const [currentLanguage, setCurrentLanguage] = useState<string | undefined>();

  useEffect(() => {
    async function initialState() {
      const cookie = (await getCookie('NEXT_LOCALE'))?.toString() || 'de';

      setCurrentLanguage(cookie);
    }

    void initialState();
  }, []);

  const setPath = useCallback(
    (locale: string) => {
      void replace({ pathname, query }, asPath, { locale });
    },
    [asPath, pathname, query, replace]
  );

  const setLanguage = useCallback(
    async (locale?: string) => {
      const currentLanguage = (await getCookie('NEXT_LOCALE'))?.toString();
      if (locale && currentLanguage !== locale) {
        await setCookie('NEXT_LOCALE', locale);
      }

      if (locale && routeLocale !== locale) {
        setPath(locale);
      }
    },
    [routeLocale, setPath]
  );

  const appLanguage = useMemo(() => {
    return (
      currentLanguage?.toLocaleUpperCase() ??
      i18n?.language.toLocaleUpperCase() ??
      'DE'
    );
  }, [currentLanguage]);

  return {
    currentLanguage,
    setLanguage,
    setPath,
    appLanguage,
  };
};

export default useLocale;
